const coordinateClipboardPattern = /^[-+]?[\d\s.,]+[;,\s]+[-+]?[\d\s.,]+$/;
const numberWithSpacesPattern = /^[-+]?[\d\s]+(?:[.,]\d+)?$/;

export function normalizeClipboardValue(raw: unknown): string {
  if (typeof raw !== 'string') {
    return raw == null ? '' : String(raw);
  }
  const trimmed = raw.trim();
  if (trimmed === '') {
    return '';
  }
  if (coordinateClipboardPattern.test(trimmed)) {
    const parts = trimmed
      .split(/[;,\s]+/)
      .map(part => part.trim())
      .filter(Boolean);
    if (parts.length === 2) {
      const [lat, lon] = parts.map(part => part.replace(',', '.'));
      return `${lat}, ${lon}`;
    }
  }
  if (numberWithSpacesPattern.test(trimmed)) {
    return trimmed.replace(/(?<=\d)[\s\u00A0]+(?=\d)/g, '').replace(',', '.');
  }
  return trimmed;
}
